import React from 'react';

/**
 * Inlined so the artwork renders with no network request - this modal is shown
 * precisely when the device is offline.
 */
const ConnectingIllustration = (props) => (
  <svg
    width="160"
    height="160"
    viewBox="0 0 160 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style>{`
  @keyframes kf_headband-tail-2_transform_0 {
    0% {
      animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
      transform: translateX(119.129px) translateY(30.084px) translate(0.163px, 1.66px) rotate(0rad) translate(-0.163px, -1.66px) rotate(-0.018rad) scaleX(1) scaleY(1);
    }
    60% {
      animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
      transform: translateX(119.129px) translateY(30.084px) translate(0.163px, 1.66px) rotate(0.087rad) translate(-0.163px, -1.66px) rotate(-0.018rad) scaleX(1) scaleY(1);
    }
    100% {
      transform: translateX(119.129px) translateY(30.084px) translate(0.163px, 1.66px) rotate(0rad) translate(-0.163px, -1.66px) rotate(-0.018rad) scaleX(1) scaleY(1);
    }
  }
  #headband-tail-2 {
    transform-origin: 0 0;
    animation: kf_headband-tail-2_transform_0 1s linear infinite;
  }
  @keyframes kf_headband-tail-1_transform_0 {
    0% {
      animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
      transform: translateX(115.305px) translateY(29.75px) translate(0.784px, 1.56px) rotate(0rad) translate(-0.784px, -1.56px) rotate(-0.476rad) scaleX(1) scaleY(1);
    }
    40% {
      animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
      transform: translateX(115.305px) translateY(29.75px) translate(0.784px, 1.56px) rotate(0.087rad) translate(-0.784px, -1.56px) rotate(-0.476rad) scaleX(1) scaleY(1);
    }
    100% {
      transform: translateX(115.305px) translateY(29.75px) translate(0.784px, 1.56px) rotate(0rad) translate(-0.784px, -1.56px) rotate(-0.476rad) scaleX(1) scaleY(1);
    }
  }
  #headband-tail-1 {
    transform-origin: 0 0;
    animation: kf_headband-tail-1_transform_0 1s linear infinite;
  }
  @keyframes kf_face_transform_0 {
    0% {
      transform: translateX(51.383px) translateY(70.562px) translateY(0px);
    }
    1.13% {
      animation-timing-function: ease-in-out;
      transform: translateX(51.383px) translateY(70.562px) translateY(0px);
    }
    50% {
      animation-timing-function: ease-in-out;
      transform: translateX(51.383px) translateY(70.562px) translateY(-3.37px);
    }
    100% {
      transform: translateX(51.383px) translateY(70.562px) translateY(0px);
    }
  }
  #face {
    transform-origin: 0 0;
    animation: kf_face_transform_0 1s linear infinite;
  }
  @keyframes kf_R_arm_transform_0 {
    0% {
      animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
      transform: translateX(45.613px) translateY(93.936px) translate(-26.173px, 3.923px) rotate(0rad) translate(26.173px, -3.923px) rotate(3.142rad) scaleY(-1) skewX(0rad);
    }
    50% {
      animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
      transform: translateX(45.613px) translateY(93.936px) translate(-26.173px, 3.923px) rotate(-0.873rad) translate(26.173px, -3.923px) rotate(3.142rad) scaleY(-1) skewX(0rad);
    }
    89.58% {
      transform: translateX(45.613px) translateY(93.936px) translate(-26.173px, 3.923px) rotate(0rad) translate(26.173px, -3.923px) rotate(3.142rad) scaleY(-1) skewX(0rad);
    }
    100% {
      transform: translateX(45.613px) translateY(93.936px) translate(-26.173px, 3.923px) rotate(0rad) translate(26.173px, -3.923px) rotate(3.142rad) scaleY(-1) skewX(0rad);
    }
  }
  #R_arm {
    transform-origin: 0 0;
    animation: kf_R_arm_transform_0 1s linear infinite;
  }
  @keyframes kf_book_open_animate_transform_0 {
    0% {
      transform: translateX(32.055px) translateY(77.753px) translateY(-0.128px);
    }
    8.33% {
      transform: translateX(32.055px) translateY(77.753px) translateY(-0.128px);
    }
    50% {
      transform: translateX(32.055px) translateY(77.753px) translateY(-1.252px);
    }
    89.58% {
      transform: translateX(32.055px) translateY(77.753px) translateY(-0.128px);
    }
    100% {
      transform: translateX(32.055px) translateY(77.753px) translateY(-0.128px);
    }
  }
  #book_open_animate {
    transform-origin: 0 0;
    animation: kf_book_open_animate_transform_0 1s linear infinite;
  }
  @keyframes kf_paper_transform_0 {
    0% {
      transform: translateX(17.028px) translateY(0px) translateX(0px) translate(14.408px, 26.851px) scaleX(1) translate(-14.408px, -26.851px);
    }
    8.33% {
      animation-timing-function: cubic-bezier(0.25, 0.1, 0.75, 0.4);
      transform: translateX(17.028px) translateY(0px) translateX(0px) translate(14.408px, 26.851px) scaleX(1) translate(-14.408px, -26.851px);
    }
    50% {
      animation-timing-function: cubic-bezier(0.25, 0.6, 0.6, 1);
      transform: translateX(17.028px) translateY(0px) translateX(18.01px) translate(14.408px, 26.851px) scaleX(0) translate(-14.408px, -26.851px);
    }
    89.58% {
      transform: translateX(17.028px) translateY(0px) translateX(36.019px) translate(14.408px, 26.851px) scaleX(-1) translate(-14.408px, -26.851px);
    }
    99.99% {
      transform: translateX(17.028px) translateY(0px) translateX(36.019px) translate(14.408px, 26.851px) scaleX(-1) translate(-14.408px, -26.851px);
    }
    100% {
      transform: translateX(17.028px) translateY(0px) translateX(0px) translate(14.408px, 26.851px) scaleX(1) translate(-14.408px, -26.851px);
    }
  }
  @keyframes kf_paper_opacity_0 {
    0% {
      animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
      opacity: 0;
    }
    18.75% {
      animation-timing-function: linear;
      opacity: 1;
    }
    81.19% {
      animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  #paper {
    transform-origin: 0 0;
    animation:
      kf_paper_transform_0 1s linear infinite,
      kf_paper_opacity_0 1s linear infinite;
  }
  @keyframes kf_L_arm_transform_0 {
    0% {
      transform: translateX(109.461px) translateY(93.936px) translate(27.334px, 6.566px) rotate(0rad) translate(-27.334px, -6.566px);
    }
    0.1% {
      animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
      transform: translateX(109.461px) translateY(93.936px) translate(27.334px, 6.566px) rotate(0rad) translate(-27.334px, -6.566px);
    }
    50% {
      animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
      transform: translateX(109.461px) translateY(93.936px) translate(27.334px, 6.566px) rotate(0.052rad) translate(-27.334px, -6.566px);
    }
    89.58% {
      transform: translateX(109.461px) translateY(93.936px) translate(27.334px, 6.566px) rotate(0rad) translate(-27.334px, -6.566px);
    }
    100% {
      transform: translateX(109.461px) translateY(93.936px) translate(27.334px, 6.566px) rotate(0rad) translate(-27.334px, -6.566px);
    }
  }
  #L_arm {
    transform-origin: 0 0;
    animation: kf_L_arm_transform_0 1s linear infinite;
  }
  @keyframes kf_headband_transform_0 {
    0% {
      animation-timing-function: ease-in-out;
      transform: translateX(27.215px) translateY(18.876px) translateX(0px) translateY(0px) translate(50.253px, 0px) scaleX(1) scaleY(1) translate(-50.253px, 0px);
    }
    41.67% {
      animation-timing-function: ease-in-out;
      transform: translateX(27.215px) translateY(18.876px) translateX(0px) translateY(-1.124px) translate(50.253px, 0px) scaleX(0.98) scaleY(0.95) translate(-50.253px, 0px);
    }
    100% {
      transform: translateX(27.215px) translateY(18.876px) translateX(0px) translateY(0px) translate(50.253px, 0px) scaleX(1) scaleY(1) translate(-50.253px, 0px);
    }
  }
  #headband {
    transform-origin: 0 0;
    animation: kf_headband_transform_0 1s linear infinite;
  }
  `}</style>
    <g id="Animate_Loading_ReadingBook" filter="url(#filter0_n_17216_274658)">
      <g clipPath="url(#clip0_17216_274658)">
        <ellipse
          id="shadow"
          opacity="0.5"
          transform="translate(11.0352 113.708)"
          cx="66.5169"
          cy="22.4719"
          rx="66.5169"
          ry="22.4719"
          fill="#737D8C"
          fillOpacity="0.5"
        />
        <g
          id="headband-tail-2"
          filter="url(#filter1_n_17216_274658)"
          transform="translate(119.129 30.0845) rotate(-1.00455)"
        >
          <path
            d="M12.7886 2.66093C8.12034 -2.0071 -4.1105 0.327118 1.39814 3.12885C8.90173 6.94523 9.52119 13.6784 23.8994 16.1058C31.363 17.3659 32.209 6.91426 28.3808 4.20226C26.14 2.61484 20.8182 10.6902 12.7886 2.66093Z"
            fill="url(#paint0_radial_17216_274658)"
          />
        </g>
        <g
          id="headband-tail-1"
          filter="url(#filter2_n_17216_274658)"
          transform="translate(115.305 29.7505) rotate(-27.2545)"
        >
          <path
            d="M12.7886 2.66093C8.12034 -2.0071 -4.1105 0.327118 1.39814 3.12885C8.90173 6.94523 9.52119 13.6784 23.8994 16.1058C31.363 17.3659 32.209 6.91426 28.3808 4.20226C26.14 2.61484 20.8182 10.6902 12.7886 2.66093Z"
            fill="url(#paint1_radial_17216_274658)"
          />
        </g>
        <path
          id="Vector"
          transform="translate(12.3828 3.5957)"
          d="M66.1289 0.28125C76.3976 0.28125 87.3823 5.47243 97.3115 14.0156C107.237 22.5553 116.082 34.4229 122.069 47.7217C134.047 74.3237 134.568 106.576 109.563 129.384C98.9658 139.05 78.9194 143.684 58.873 141.765C38.8336 139.845 18.8975 131.387 8.49219 114.993C-1.52163 99.2168 -0.918036 81.1225 2.64844 66.2285C6.21443 51.3369 12.732 39.6872 14.4854 36.8486L14.4863 36.8496C18.1258 30.9781 32.1179 0.281301 66.1289 0.28125Z"
          fill="url(#paint2_radial_17216_274658)"
          stroke="url(#paint3_radial_17216_274658)"
          strokeWidth="0.561798"
        />
        <g id="Vector_2" transform="matrix(-1 0 0 1 142.594 114)">
          <path
            d="M42.1365 32.2727C46.0033 26.0596 41.0583 17.3825 40.1901 15.8468C32.7441 2.78171 12.3187 -4.44048 3.98633 2.98768C-0.937946 7.37836 0.0261751 15.401 0.171312 16.5977C1.67969 29.1649 15.6232 37.3804 27.0371 37.7168C29.634 37.8184 38.521 38.087 42.1365 32.2727Z"
            fill="url(#paint4_radial_17216_274658)"
          />
          <path
            d="M42.1365 32.2727C46.0033 26.0596 41.0583 17.3825 40.1901 15.8468C32.7441 2.78171 12.3187 -4.44048 3.98633 2.98768C-0.937946 7.37836 0.0261751 15.401 0.171312 16.5977C1.67969 29.1649 15.6232 37.3804 27.0371 37.7168C29.634 37.8184 38.521 38.087 42.1365 32.2727Z"
            fill="url(#paint5_radial_17216_274658)"
            fillOpacity="0.2"
          />
        </g>
        <g id="Vector_3" transform="translate(13.1797 113.708)">
          <path
            d="M42.1365 32.2727C46.0033 26.0596 41.0583 17.3825 40.1901 15.8468C32.7441 2.78171 12.3187 -4.44048 3.98633 2.98768C-0.937946 7.37836 0.0261751 15.401 0.171312 16.5977C1.67969 29.1649 15.6232 37.3804 27.0371 37.7168C29.634 37.8184 38.521 38.087 42.1365 32.2727Z"
            fill="url(#paint6_radial_17216_274658)"
          />
          <path
            d="M42.1365 32.2727C46.0033 26.0596 41.0583 17.3825 40.1901 15.8468C32.7441 2.78171 12.3187 -4.44048 3.98633 2.98768C-0.937946 7.37836 0.0261751 15.401 0.171312 16.5977C1.67969 29.1649 15.6232 37.3804 27.0371 37.7168C29.634 37.8184 38.521 38.087 42.1365 32.2727Z"
            fill="url(#paint7_radial_17216_274658)"
            fillOpacity="0.2"
          />
        </g>
        <g id="face" transform="translate(51.3828 70.5615)">
          <path
            id="Vector_4"
            transform="matrix(0.984561 -0.175044 0.177257 0.984165 4.92528 1.9879)"
            d="M0.65054 4.11359C1.12658 1.40995 3.71755 -0.398061 6.4374 0.0752842L6.5945 0.102494C9.31435 0.575746 11.1329 3.15109 10.6569 5.85474L10.082 9.11822C9.606 11.8218 7.01504 13.6298 4.29519 13.1565L4.13808 13.1293C1.41823 12.656 -0.40034 10.0806 0.0757043 7.37707L0.65054 4.11359Z"
            fill="#82333E"
          />
          <path
            id="Vector_5"
            transform="matrix(0.984561 -0.175044 0.177257 0.984165 34.7725 1.87884)"
            d="M0.649834 4.11356C1.12682 1.41001 3.71777 -0.397994 6.43763 0.0752574L6.5938 0.102467C9.31365 0.575719 11.1332 3.15116 10.6571 5.85471L10.0823 9.11819C9.60625 11.8218 7.01528 13.6298 4.29448 13.1565L4.13831 13.1293C1.41846 12.656 -0.401039 10.0807 0.0759461 7.37705L0.649834 4.11356Z"
            fill="#82333E"
          />
          <path
            id="Vector_6"
            transform="matrix(0.984561 -0.175044 0.177257 0.984165 22.6272 8.29628)"
            d="M7.37334 3.13214C7.13909 4.4625 5.30358 5.25472 3.27427 4.90163C1.24497 4.54854 -0.209502 3.18385 0.0247572 1.85349C0.259016 0.523132 2.09358 -0.269077 4.12288 0.0840153C6.15219 0.437107 7.6076 1.80178 7.37334 3.13214Z"
            fill="#EB8C31"
          />
          <path
            id="Vector_7"
            transform="matrix(0.999993 -0.00374076 0.00378958 0.999993 4.11418 16.9023)"
            d="M1.27048 2.52455C1.97215 2.52455 2.54098 1.95941 2.54098 1.26228C2.54098 0.565145 1.97215 0 1.27048 0C0.568814 0 0 0.565145 0 1.26228C0 1.95941 0.568814 2.52455 1.27048 2.52455Z"
            fill="#EB8C31"
          />
          <path
            id="Vector_8"
            transform="matrix(0.999993 -0.00374076 0.00378958 0.999993 -0.000984192 20.8464)"
            d="M1.27048 2.52454C1.97215 2.52454 2.54096 1.95941 2.54096 1.26227C2.54096 0.565138 1.97215 0 1.27048 0C0.568814 0 0 0.565138 0 1.26227C0 1.95941 0.568814 2.52454 1.27048 2.52454Z"
            fill="#EB8C31"
          />
          <path
            id="Vector_9"
            transform="matrix(0.999993 -0.00374076 0.00378958 0.999993 7.93968 20.8182)"
            d="M1.27048 2.52454C1.97215 2.52454 2.54096 1.95941 2.54096 1.26227C2.54096 0.565138 1.97215 0 1.27048 0C0.568814 0 0 0.565138 0 1.26227C0 1.95941 0.568814 2.52454 1.27048 2.52454Z"
            fill="#EB8C31"
          />
          <path
            id="Vector_10"
            transform="matrix(-0.999993 0.00374063 0.00378945 0.999993 48.8807 16.2549)"
            d="M1.27048 2.52455C1.97215 2.52455 2.54097 1.95941 2.54097 1.26227C2.54097 0.565139 1.97215 0 1.27048 0C0.568815 0 0 0.565139 0 1.26227C0 1.95941 0.568815 2.52455 1.27048 2.52455Z"
            fill="#EB8C31"
          />
          <path
            id="Vector_11"
            transform="matrix(-0.999993 0.00374063 0.00378945 0.999993 53.0222 20.0265)"
            d="M1.27048 2.52455C1.97215 2.52455 2.54097 1.95941 2.54097 1.26227C2.54097 0.565139 1.97215 0 1.27048 0C0.568815 0 0 0.565139 0 1.26227C0 1.95941 0.568815 2.52455 1.27048 2.52455Z"
            fill="#EB8C31"
          />
          <path
            id="Vector_12"
            transform="matrix(-0.999993 0.00374063 0.00378945 0.999993 45.5643 20.6811)"
            d="M1.27048 2.52455C1.97215 2.52455 2.54097 1.95941 2.54097 1.26227C2.54097 0.565139 1.97215 0 1.27048 0C0.568815 0 0 0.565139 0 1.26227C0 1.95941 0.568815 2.52455 1.27048 2.52455Z"
            fill="#EB8C31"
          />
        </g>
        <g id="R_arm" transform="matrix(-1 0 0 1 45.6133 93.9355)">
          <path
            id="Vector_13"
            transform="translate(0.899763 10.3741) rotate(-19.5691)"
            d="M15.1709 0.259544C13.5582 0.790247 13.7511 1.66757 11.6973 2.56881C8.78051 3.85015 7.54872 3.39356 4.70668 3.54177C2.37568 3.6613 0.312253 6.20007 0.0663775 8.35396C-0.45189 12.8817 2.14427 15.6858 5.08031 17.2612C11.3212 20.608 22.658 17.6461 25.353 11.8633C26.7294 8.91096 25.9291 6.29091 24.0634 3.85733C22.0096 1.19425 18.1407 -0.718194 15.1709 0.259544Z"
            fill="black"
            fillOpacity="0.2"
          />
          <g id="Vector_14" transform="translate(0.000886917 9.03204) rotate(-19.5691)">
            <path
              d="M15.7069 0.268714C14.0373 0.818169 14.2369 1.72649 12.1106 2.65958C9.09074 3.98619 7.81543 3.51346 4.87298 3.66691C2.45962 3.79066 0.323286 6.41914 0.0687228 8.64913C-0.467857 13.3368 2.22003 16.24 5.25981 17.8711C11.7212 21.3361 23.4586 18.2695 26.2488 12.2825C27.6739 9.22581 26.8453 6.51319 24.9136 3.99362C22.7872 1.23644 18.7816 -0.74357 15.7069 0.268714Z"
              fill="url(#paint8_radial_17216_274658)"
            />
            <path
              d="M15.7069 0.268714C14.0373 0.818169 14.2369 1.72649 12.1106 2.65958C9.09074 3.98619 7.81543 3.51346 4.87298 3.66691C2.45962 3.79066 0.323286 6.41914 0.0687228 8.64913C-0.467857 13.3368 2.22003 16.24 5.25981 17.8711C11.7212 21.3361 23.4586 18.2695 26.2488 12.2825C27.6739 9.22581 26.8453 6.51319 24.9136 3.99362C22.7872 1.23644 18.7816 -0.74357 15.7069 0.268714Z"
              fill="url(#paint9_radial_17216_274658)"
              fillOpacity="0.2"
            />
          </g>
        </g>
        <g
          id="book_open_animate"
          filter="url(#filter3_d_17216_274658)"
          transform="translate(32.0547 77.7529)"
        >
          <path
            id="paper"
            transform="translate(17.0277 7.46138e-05)"
            d="M28.8154 53.7014V9.76403C28.8154 0.654896 0 0 0 0V39.643L28.8154 53.7014Z"
            fill="#DEE2E6"
          />
          <g id="book" transform="translate(-8.77809e-05 1.85358)">
            <path
              id="Vector_15"
              transform="translate(2.94763 3.94583e-05)"
              d="M42.8957 12.5522L0 0.88274C0 0.88274 5.24358 0.323331 6.22151 0.229558C10.1509 -0.147226 9.16854 -0.479755 26.1958 2.86033C39.5396 5.47786 44.5329 4.36544 42.8957 12.5522Z"
              fill="#F1F3F5"
            />
            <path
              id="Vector_16"
              transform="matrix(-1 0 0 1 89.0396 3.94583e-05)"
              d="M42.8957 12.5522L0 0.88274C0 0.88274 5.24358 0.323331 6.22151 0.229558C10.1509 -0.147226 9.16854 -0.479755 26.1958 2.86033C39.5396 5.47786 44.5329 4.36544 42.8957 12.5522Z"
              fill="#F1F3F5"
            />
            <path
              id="Vector_17"
              transform="translate(-5.26685e-05 0.503024)"
              d="M0 1.31051C0 0.449952 0.815724 -0.176774 1.64723 0.0449282L39.2936 10.0825V66.4035L0.933471 54.897C0.379428 54.7308 0 54.2208 0 53.6424V1.31051Z"
              fill="#FF6363"
            />
            <path
              id="Vector_18"
              transform="matrix(-1 0 0 1 91.6853 0.503024)"
              d="M0 1.31051C0 0.449952 0.815724 -0.176774 1.64723 0.0449282L39.2936 10.0825V66.4035L0.933471 54.897C0.379428 54.7308 0 54.2208 0 53.6424V1.31051Z"
              fill="#FF6363"
            />
            <path
              id="Vector_19"
              transform="matrix(-1 0 0 1 86.4466 11.6849)"
              d="M0 1.31062C0 0.436913 0.839182 -0.19186 1.67771 0.0535627L25.9088 7.1456C26.4671 7.30899 26.8507 7.82098 26.8507 8.40266V20.9248C26.8507 21.8019 26.0055 22.4311 25.1653 22.1796L0.934166 14.9258C0.379774 14.7599 0 14.2498 0 13.6711V1.31062Z"
              fill="black"
              fillOpacity="0.2"
            />
            <path
              id="Vector_20"
              transform="translate(38.6393 9.93245)"
              d="M0 1.30979C0 0.586412 0.586414 0 1.30979 0H13.0979C13.8213 0 14.4077 0.586414 14.4077 1.30979V56.321C14.4077 57.0444 13.8213 57.6308 13.0979 57.6308H1.30979C0.586413 57.6308 0 57.0444 0 56.321V1.30979Z"
              fill="#D63F3F"
            />
          </g>
        </g>
        <g id="L_arm" transform="translate(109.461 93.9355)">
          <path
            id="Vector_21"
            transform="translate(0.448851 10.3809) rotate(-19.5691)"
            d="M15.1709 0.259544C13.5582 0.790247 13.7511 1.66757 11.6973 2.56881C8.78051 3.85015 7.54872 3.39356 4.70668 3.54177C2.37568 3.6613 0.312253 6.20007 0.0663775 8.35396C-0.45189 12.8817 2.14427 15.6858 5.08031 17.2612C11.3212 20.608 22.658 17.6461 25.353 11.8633C26.7294 8.91096 25.9291 6.29091 24.0634 3.85733C22.0096 1.19425 18.1407 -0.718194 15.1709 0.259544Z"
            fill="black"
            fillOpacity="0.2"
          />
          <g id="Vector_22" transform="translate(-0.000587463 9.03227) rotate(-19.5691)">
            <path
              d="M15.7069 0.268714C14.0373 0.818169 14.2369 1.72649 12.1106 2.65958C9.09074 3.98619 7.81543 3.51346 4.87298 3.66691C2.45962 3.79066 0.323286 6.41914 0.0687228 8.64913C-0.467857 13.3368 2.22003 16.24 5.25981 17.8711C11.7212 21.3361 23.4586 18.2695 26.2488 12.2825C27.6739 9.22581 26.8453 6.51319 24.9136 3.99362C22.7872 1.23644 18.7816 -0.74357 15.7069 0.268714Z"
              fill="url(#paint10_radial_17216_274658)"
            />
            <path
              d="M15.7069 0.268714C14.0373 0.818169 14.2369 1.72649 12.1106 2.65958C9.09074 3.98619 7.81543 3.51346 4.87298 3.66691C2.45962 3.79066 0.323286 6.41914 0.0687228 8.64913C-0.467857 13.3368 2.22003 16.24 5.25981 17.8711C11.7212 21.3361 23.4586 18.2695 26.2488 12.2825C27.6739 9.22581 26.8453 6.51319 24.9136 3.99362C22.7872 1.23644 18.7816 -0.74357 15.7069 0.268714Z"
              fill="url(#paint11_radial_17216_274658)"
              fillOpacity="0.2"
            />
          </g>
        </g>
        <g
          id="headband"
          filter="url(#filter4_n_17216_274658)"
          transform="translate(27.2148 18.8765)"
        >
          <path
            d="M100.506 19.3258C69.1284 8.79931 20.9509 14.9398 0.784384 19.3258C-2.07387 13.7157 3.56324 8.37367 6.73908 6.40391C39.1961 -5.19419 78.4336 1.57137 93.9952 6.40391C98.5684 8.73613 100.241 15.9903 100.506 19.3258Z"
            fill="url(#paint12_radial_17216_274658)"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_n_17216_274658"
        x="0"
        y="0"
        width="160"
        height="160"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="12.5 12.5"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3862"
        />
        <feComponentTransfer in="noise" result="coloredNoise1">
          <feFuncR type="linear" slope="2" intercept="-0.5" />
          <feFuncG type="linear" slope="2" intercept="-0.5" />
          <feFuncB type="linear" slope="2" intercept="-0.5" />
          <feFuncA
            type="discrete"
            tableValues="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite operator="in" in2="shape" in="coloredNoise1" result="noise1Clipped" />
        <feComponentTransfer in="noise1Clipped" result="color1">
          <feFuncA type="table" tableValues="0 0.15" />
        </feComponentTransfer>
        <feMerge result="effect1_noise_17216_274658">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter1_n_17216_274658"
        x="-0.245214"
        y="-0.0878175"
        width="31.0194"
        height="16.394"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="21.249382019042969 21.249382019042969"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3862"
        />
        <feComponentTransfer in="noise" result="coloredNoise1">
          <feFuncR type="linear" slope="2" intercept="-0.5" />
          <feFuncG type="linear" slope="2" intercept="-0.5" />
          <feFuncB type="linear" slope="2" intercept="-0.5" />
          <feFuncA
            type="discrete"
            tableValues="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite operator="in" in2="shape" in="coloredNoise1" result="noise1Clipped" />
        <feComponentTransfer in="noise1Clipped" result="color1">
          <feFuncA type="table" tableValues="0 0.15" />
        </feComponentTransfer>
        <feMerge result="effect1_noise_17216_274658">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter2_n_17216_274658"
        x="-1.6841"
        y="-7.91747"
        width="34.8743"
        height="27.3236"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="21.249382019042969 21.249382019042969"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3862"
        />
        <feComponentTransfer in="noise" result="coloredNoise1">
          <feFuncR type="linear" slope="2" intercept="-0.5" />
          <feFuncG type="linear" slope="2" intercept="-0.5" />
          <feFuncB type="linear" slope="2" intercept="-0.5" />
          <feFuncA
            type="discrete"
            tableValues="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite operator="in" in2="shape" in="coloredNoise1" result="noise1Clipped" />
        <feComponentTransfer in="noise1Clipped" result="color1">
          <feFuncA type="table" tableValues="0 0.15" />
        </feComponentTransfer>
        <feMerge result="effect1_noise_17216_274658">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <filter
        id="filter3_d_17216_274658"
        x="0"
        y="0"
        width="91.6836"
        height="71.6661"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2.24719" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17216_274658" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_17216_274658"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_n_17216_274658"
        x="0"
        y="0"
        width="100.504"
        height="19.3257"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="21.249382019042969 21.249382019042969"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="3862"
        />
        <feComponentTransfer in="noise" result="coloredNoise1">
          <feFuncR type="linear" slope="2" intercept="-0.5" />
          <feFuncG type="linear" slope="2" intercept="-0.5" />
          <feFuncB type="linear" slope="2" intercept="-0.5" />
          <feFuncA
            type="discrete"
            tableValues="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
          />
        </feComponentTransfer>
        <feComposite operator="in" in2="shape" in="coloredNoise1" result="noise1Clipped" />
        <feComponentTransfer in="noise1Clipped" result="color1">
          <feFuncA type="table" tableValues="0 0.15" />
        </feComponentTransfer>
        <feMerge result="effect1_noise_17216_274658">
          <feMergeNode in="shape" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <radialGradient
        id="paint0_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.5136 -1.77396) rotate(106.272) scale(17.9936 36.7886)"
      >
        <stop stopColor="#FDA678" />
        <stop offset="0.5" stopColor="#E84E3C" />
        <stop offset="1" stopColor="#89231F" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.5136 -1.77396) rotate(106.272) scale(17.9936 36.7886)"
      >
        <stop stopColor="#FDA678" />
        <stop offset="0.5" stopColor="#E84E3C" />
        <stop offset="1" stopColor="#89231F" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(82.2274 121.148 -103.525 66.338 32.9676 42.6485)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.5" stopColor="white" />
        <stop offset="0.8" stopColor="#ABC9CE" />
        <stop offset="1" stopColor="#7DA1BC" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-194.542 -37.0485 81.775 -402.777 56.879 74.4883)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DEE2E6" stopOpacity="0" />
        <stop offset="1" stopColor="#ABC9CE" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(6.96636 21.0246 -35.8155 12.0102 13.2586 -3.84321)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29629B" />
        <stop offset="0.324986" stopColor="#33599A" />
        <stop offset="0.730207" stopColor="#294A7F" />
        <stop offset="1" stopColor="#2B336D" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(14.1574 8.36463 -6.86091 12.1626 -0.018434 6.32999)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF8C5" />
        <stop offset="1" stopColor="#FFF8C5" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(6.96636 21.0246 -35.8155 12.0102 13.2586 -3.84321)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29629B" />
        <stop offset="0.324986" stopColor="#33599A" />
        <stop offset="0.730207" stopColor="#294A7F" />
        <stop offset="1" stopColor="#2B336D" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(14.1574 8.36463 -6.86091 12.1626 -0.018434 6.32999)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF8C5" />
        <stop offset="1" stopColor="#FFF8C5" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-3.02897 16.5719 -13.5147 -1.98358 17.1169 0.0700975)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29629B" />
        <stop offset="0.324986" stopColor="#33599A" />
        <stop offset="0.730207" stopColor="#294A7F" />
        <stop offset="1" stopColor="#2B336D" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-17.5793 -9.58793 6.73195 -12.4129 22.7917 4.23379)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF8C5" />
        <stop offset="1" stopColor="#FFF8C5" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-5.23987 24.1333 -19.7048 -3.56029 20.0685 -4.12383)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29629B" />
        <stop offset="0.324986" stopColor="#33599A" />
        <stop offset="0.730207" stopColor="#294A7F" />
        <stop offset="1" stopColor="#2B336D" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(11.6415 11.5316 -8.11256 8.22884 22.2148 5.94042)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF8C5" />
        <stop offset="1" stopColor="#FFF8C5" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_17216_274658"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(24.3746 64.3726 -83.1676 31.0136 27.9473 3.86079)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EC9364" />
        <stop offset="0.5" stopColor="#E7473B" />
        <stop offset="1" stopColor="#7B2019" />
      </radialGradient>
      <clipPath id="clip0_17216_274658">
        <rect width="160" height="160" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ConnectingIllustration;
